/*
 * Public API Surface of propeller-components
 */

export * from './lib/components/body/body.component';
export * from './lib/components/body/body.module';
